import { User } from './../objects/real-time';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import { Http , Response,Headers, RequestOptions} from '@angular/http';
import {GlobalService} from "./global.config";
import {Fueling, Provider, FuelingInfo, Type, DateInterval, DashbordInfo} from '../pages/gestion-park/model/index';
import {Events } from 'ionic-angular';

@Injectable()
export class FuelingService {
    currentuser:User;
dns:string;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
        this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
       this.dns = globalService.getDns();
        console.log(this.dns);

    }

    getListFueling(idVehicule: number): Observable<FuelingInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'fuelings/list/' + idVehicule, {headers: headers}).map(res => res.json());
    }

    getListType(type: string): Observable<Type[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'types/list?type=' + type, {headers: headers}).map(res => res.json());
    }

    getProviders(type: string): Observable<Provider[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'providers/listByType?type=' + type, {headers: headers}).map(res => res.json());
    }

    public getDataInExcel(idVehicule: number, date: DateInterval): Observable<Boolean> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(date);
        return this._http.post(this.dns + 'fuelings/exportExcel/' + idVehicule, date, options).map(res => res.json());
    }

    readData(idVehicule: number, fileName: string): Observable<FuelingInfo[]> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'fuelings/readData/' + idVehicule + '?fileName=' + fileName, {headers: headers}).map(res => res.json());
    }

    delete(id: number): Observable<Boolean> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.delete(this.dns + 'fuelings/' + id, {headers: headers}).map(res => res.json());
    }

    public add(fueling: Fueling, idVehicule: number, idProvider: number, idType: number, providerName: string, typePayment: string): Observable<FuelingInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(fueling);
        return this._http.post(this.dns + 'fuelings?idVehicule=' + idVehicule + '&idProvider=' + idProvider + '&idType=' + idType + '&providerName=' + providerName + '&typePayment=' + typePayment, fueling, options).map(res => res.json());
    }

    public update(fueling: Fueling, idProvider: number, idType: number, providerName: string, typePayment: string): Observable<FuelingInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(fueling);
        return this._http.put(this.dns + 'fuelings?idProvider=' + idProvider + '&idType=' + idType + '&providerName=' + providerName + '&typePayment=' + typePayment, fueling, options).map(res => res.json());
    }
    public getDashbordInfo(idVehicule: number, date: DateInterval): Observable<DashbordInfo> {
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(date);
        return this._http.post(this.dns + 'vehicules/' + idVehicule, date, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/providers/fueling.service.ts